const initialState = {
    tokenUpdateSuccessFlag: false,
    isLoaderStatus: false,
    /** @type {ReadonlyArray<{ eventType: string; status: string }>} Cumulative PI parity payment steps for the current session (see SecurePaymentService.logPiParityEvents). */
    piParityPaymentEventsLog: [],
};

const SecurePaymentReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_TOKEN_UPDATE_SUCCESS':{
            return  {
                ...state,
                tokenUpdateSuccessFlag:action.value
            }
        }
        case 'SET_LOADER_STATUS':{
            return  {
                ...state,
                isLoaderStatus:action.value
            }
        }
        case 'SET_PI_PARITY_PAYMENT_EVENTS_LOG': {
            return {
                ...state,
                piParityPaymentEventsLog: Array.isArray(action.records)
                    ? action.records
                    : [],
            };
        }
        case 'CLEAR_PI_PARITY_PAYMENT_EVENTS_LOG': {
            return {
                ...state,
                piParityPaymentEventsLog: [],
            };
        }
        default:
            return state;
    }

};

export default SecurePaymentReducer;
